module.exports = __webpack_public_path__ + "img/AnunciosdeRedesSociales.f99f4be9.svg";